




















































import {Vue, Component} from 'vue-property-decorator';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import DateCalendar from '@/components/common/datepicker/DateCalendar.vue';
import {addDay} from '@/utils/dateUtils';
import {DelayedDispatchReasonType} from 'supporter';

@Component({
  components: {CompSelectBox, DateCalendar}
})
export default class DelayProductOrderPopup extends Vue{
  private reasonTypeOptions = [
    {value: 'PRODUCT_PREPARE', label: '상품준비중'},
    {value: 'CUSTOMER_REQUEST', label: '고객 요청'},
    {value: 'CUSTOM_BUILD', label: '주문 제작'},
    {value: 'RESERVED_DISPATCH', label: '예약 발송'},
    {value: 'ETC', label: '기타'}
  ];

  private startDateOption = {
    dateType: 'Ymd',
    name: 'startDateOption',
    fromRanges: addDay(new Date(), 1)
  };

  private formData = {
    dispatchDueDate: addDay(new Date(), 1),
    delayedDispatchReasonType: 'PRODUCT_PREPARE' as DelayedDispatchReasonType,
    dispatchDelayDetailReason: '',
    invoiceNo: ''
  }

  private onDeliveryDelay(){
    const orderOptionNos = this.$route.query.orderProductOptionNos.toString().split(',');
    const {dispatchDueDate, dispatchDelayDetailReason, delayedDispatchReasonType} = this.formData

    this.$api.putNaverPayDelayProductOrder({
      data: {
        orderOptionNos,
        dispatchDueDate,
        delayedDispatchReasonType,
        dispatchDelayDetailReason
      }
    }).then(()=>{
      alert(this.$t('네이버페이 발송지연 처리가 요청되었습니다. 상세 처리내용은 주문상세에서 확인해주세요.'))
      this.onClose()
    })
  }

  private onClose(){
    window.opener.location.reload();
    window.close()
  }
}
